import * as constants from './constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const storagesReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_STORAGES:
    return { ...state, loading: true };
  case constants.GET_STORAGES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_STORAGES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_STORAGES:
    return initialState;
  default:
    return state;
  }
};
